import React from 'react';
import { EXTERNAL_LINK } from '../TransferAccount.meta';
import { Link } from '../../../../../CommonComponents/OPL/Link/Link';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import {
  Popover,
  PopoverContent,
  PopoverTriggerButton,
} from '../../../../../CommonComponents/OPL/Popover/Popover';

interface Props {
  onClick?: () => void;
}

export const TransferAccountPopover: React.FC<Props> = ({ children }) => {
  return (
    <Popover>
      <PopoverTriggerButton aria-label="Info">{children}</PopoverTriggerButton>

      <PopoverContent side="right" width={250} p="16">
        <Text fontWeight={500}>What is ACAT/In-Kind Transfer?</Text>

        <Text color="neutral.500" mt="4" mb="8">
          The Automated Customer Account Transfer Service (ACATS) system automates and standardizes
          procedures for the transfer of assets in a customer account from one broker-dealer and/or
          bank to another.
        </Text>

        <Link isExternal href={EXTERNAL_LINK}>
          Learn more
        </Link>
      </PopoverContent>
    </Popover>
  );
};
